/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_LoadInputs */

const vi_common_error_load = /** @type {(inputs: Common_Error_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải dữ liệu.`)
};

/**

* @param {Common_Error_LoadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_error_load = /** @type {((inputs?: Common_Error_LoadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_LoadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_error_load(inputs)
});